import type {CreateExtensionArgument} from '@wix/document-manager-core'
import type {BuilderEditorClientSpecMapEntry, ComponentInCsm, BuilderComponentInCsm} from '@wix/document-services-types'
import {CSM_COMPONENT_TYPES} from '@wix/document-manager-utils'
import _ from 'lodash'

export const isBlocksEditor = (createExtensionArgument?: CreateExtensionArgument) =>
    createExtensionArgument?.dsConfig?.origin === 'responsiveBlocks'

interface BuilderComponentInfo {
    compType?: string
    refType?: string
}

type BuilderCompatibleComponent = ComponentInCsm | BuilderComponentInCsm

export const extractBuilderComponentInfo = (component: BuilderCompatibleComponent): BuilderComponentInfo => {
    const {type} = component

    switch (type) {
        case 'EDITOR_REACT_COMPONENT':
        case 'EDITOR_CONTEXT_PROVIDER':
        case 'EDITOR_FUNCTION_LIBRARY':
            return {
                compType: _.get(component, ['data', 'type'])
            }
        case 'STUDIO_WIDGET':
            return {
                compType: _.get(component, ['data', 'componentModel', 'componentType'])
            }
        case CSM_COMPONENT_TYPES.PAGE:
        case CSM_COMPONENT_TYPES.WIDGET:
        case CSM_COMPONENT_TYPES.PAGE_OUT_OF_IFRAME:
        case CSM_COMPONENT_TYPES.WIDGET_OUT_OF_IFRAME: {
            const refType = _.get(component, ['data', 'refType'])
            const componentType = _.get(component, ['data', 'componentType'])
            return refType && componentType ? {compType: componentType, refType} : {}
        }
        default:
            return {}
    }
}

const hasValidBuilderComponent = (component: BuilderCompatibleComponent): boolean =>
    !!extractBuilderComponentInfo(component).compType

export const hasBuilderComponents = (application: BuilderEditorClientSpecMapEntry) =>
    application.components?.some(component => hasValidBuilderComponent(component))
